<ul class="steps-list" data-e2e="captcha-step-items">
  <ng-container *ngFor="let indication of indications; let index = index">
    <li class="step-item mb-1">
      <div class="step-label mr-2" [ngClass]="{ 'text-primary': selections.length >= index }">
        <span class="label">{{ indication }}</span>
      </div>
      <div class="step-img">
        <ng-container *ngIf="!!selections && !!selections[index] && !!selections[index].img; else askFirst">
          <img [src]="selections[index].img" data-e2e="captcha-selected-img" />
          <span class="step-img-icon icon-Pencil" *ngIf="lastSelection() === index" (click)="deleteLastChoice()"></span>
          <span *ngIf="selections.length === index" class="ask-next text-primary h4 p-0 m-0">?</span>
        </ng-container>
        <ng-template #askFirst>
          <span *ngIf="selections.length === index" class="ask-next text-primary h4 p-0 m-0">?</span>
        </ng-template>
      </div>
    </li>
  </ng-container>
</ul>
